import { ConfigStateService } from '@medlogic/shared/state-config';
import { Control } from '../../model/control';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LogService, ConfigJsonService, IAtividadeComponenteDAL, EnTheme } from '@medlogic/shared/shared-interfaces';
import { LibService } from '../../service/lib.service';
import { CalculadoraService } from '../../service/calculadora.service';
import { CalculadoraConditionService } from '../../service/calculadora-condition.service';
import { MatDialog } from '@angular/material/dialog';
import { MsgPtBR } from '@medlogic/shared/shared-interfaces';
import { FormGroup, FormControl } from '@angular/forms';
import { GlobalService } from '@medlogic/shared/shared-interfaces';
import { IVariable } from '../../interface/ivariable';
import { IBubble } from '../../interface/ibubble';
import * as moment from 'moment';
@Component({
  selector: 'lib-ctr-date',
  templateUrl: './ctr-date.component.html',
  styleUrls: ['./ctr-date.component.css']
})
export class CtrDateComponent extends Control implements OnInit {

  @Input() ctrl: IAtividadeComponenteDAL;
  @Input() formGroup = new FormGroup({});
  @Input() isLoading = true;
  @Input() isMobile: boolean;
  @Input() enTheme = EnTheme.default;

  @Output() onChangeNotify = new EventEmitter<IVariable>();
  /* Evento para permitir que os filhos, netos, etc, se comuniquem com todos os pais até a AtividadeView */
  @Output() eventBubble = new EventEmitter<IBubble>();

  ptBr: any;
  date: FormControl;

  public mask2 = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };

  constructor(
    log: LogService,
    global: GlobalService,
    lib: LibService,
    cnf: ConfigStateService,
    cnfJson: ConfigJsonService,
    calc: CalculadoraService,
    calcCond: CalculadoraConditionService,
    dialog: MatDialog,
    msg: MsgPtBR
  ) {
    super(log, global, lib, cnf, cnfJson, calc, calcCond, dialog, msg);
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
      // const dt = this.global.getTypedValue(this.ctrl.ValorData).value;
      this.date = new FormControl(this.insertCurrentTime(this.ctrl.ValorData));
      this.subs.sink = this.date.valueChanges
        .subscribe(changed => {
          // const control = this.getFormControlFrom(this.ctrl);
          this.setValue(this.insertCurrentTime(changed));
          // control.setValue(changed, { onlySelf: true, emitEvent: true });
        });
      // this.dtValue = this.ctrl?.ValorData || this.global.getTypedValue(this.ctrl?.ValorTexto).value || new Date();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'ngOnInit', error.message);
    }
  }

  protected insertCurrentTime(date: any): Date {
    try {
      if (date) {
        moment.locale('pt-br');
        const _ = moment();
        date = moment(date);
        if (date.hours() === 0 && date.minutes() === 0 && date.seconds() === 0) {
          date.add({ hours: _.hour(), minutes: _.minute(), seconds: _.second() });
        }
        return date?.toDate();
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'insertCurrentTime', error.message);
    }
    return null;
  }

  /*override
   * Largura fixa, uma vez que se trata de componente de data.
   */
  getWidth(ctrl: IAtividadeComponenteDAL, ...args): string {
    try {
      if (this.global.isMobile()) {
        return `100%`;
      } else {
        return `100px`;
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'getWidth', error.message);
    }
    return '';
  }
}
